import React from 'react';
import {
  Box,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import SalonThemeColorField from './SalonThemeColorField';


export const SALON_THEME_COLOR_FIELDS = [
  'primary_color',
  'secondary_color',
  'background_color',
];

const SalonThemeColorControls = ({
  draft,
  errors = {},
  disabled = false,
  onFieldChange,
  onFieldBlur,
  registerFieldRef,
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1.5}>
      {SALON_THEME_COLOR_FIELDS.map((field) => {
        const label = t(`salon_theme.fields.${field}`);

        return (
          <Box
            key={field}
            data-testid="salon-theme-color-row"
          >
            <SalonThemeColorField
              field={field}
              label={label}
              value={draft[field]}
              error={errors[field]}
              disabled={disabled}
              compact={false}
              onChange={(value) => onFieldChange(field, value)}
              onBlur={() => onFieldBlur(field)}
              inputRef={(element) => registerFieldRef(field, element)}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default SalonThemeColorControls;
